import React from 'react';
import { Box, Typography } from '@mui/material';

// A small, text-only presentation subset. Source/model text never becomes HTML,
// executable code, external links or images; navigation uses verified source IDs.
function inlineText(text) {
  return text.split(/(\*\*[^*\n]+\*\*|`[^`\n]+`)/gu).map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    if (part.startsWith('`') && part.endsWith('`') && part.length > 2) {
      return <Box component="span" key={index} sx={{ bgcolor: 'action.hover', borderRadius: 0.5, px: 0.25 }}>{part.slice(1, -1)}</Box>;
    }
    return part;
  });
}

export default function ProjectChatText({ text }) {
  if (typeof text !== 'string' || !text) return null;
  return <Box sx={{ overflowWrap: 'anywhere', '& > :last-child': { mb: 0 } }}>
    {text.split(/\n\s*\n/gu).map((block, index) => {
      const lines = block.split('\n');
      const numbered = lines.every(line => /^\d+[.)]\s+/u.test(line));
      const bullets = lines.every(line => /^[-*]\s+/u.test(line));
      if (numbered || bullets) return <Box key={index} component={numbered ? 'ol' : 'ul'}
        sx={{ mt: 0, mb: 1.5, pl: 3 }}>
        {lines.map((line, row) => <Box key={row} component="li"
          {...(numbered ? { value: Number(line.match(/^\d+/u)[0]) } : {})} sx={{ mb: 0.5 }}>
          {inlineText(line.replace(numbered ? /^\d+[.)]\s+/u : /^[-*]\s+/u, ''))}
        </Box>)}
      </Box>;
      const heading = /^#{1,6}\s+/u.test(block);
      return <Typography key={index} component="p" sx={{ mt: 0, mb: 1.5,
        whiteSpace: 'pre-wrap', ...(heading ? { fontWeight: 600 } : {}) }}>
        {inlineText(heading ? block.replace(/^#{1,6}\s+/u, '') : block)}
      </Typography>;
    })}
  </Box>;
}
